<template>
  <div
    class="relative cursor-pointer"
    v-click-outside="handleClickOutsideTogglerLayer"
    @click.prevent="toggle()"
  >
    <slot name="toggler"></slot>
    <slot />
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
  directives: {
    ClickOutside
  },
  provide () {
    return {
      holdOnClick: this.holdOnClick,
      sharedState: this.sharedState
    }
  },
  data () {
    return {
      sharedState: {
        active: false
      }
    }
  },
  methods: {
    handleClickOutsideTogglerLayer () {
      this.hide()
    },
    toggle () {
      this.sharedState.active = !this.sharedState.active
    },
    hide () {
      this.sharedState.active = false
    }
  }
}
</script>
